import { render, staticRenderFns } from "./ItemReasonCode.vue?vue&type=template&id=9ba7b644&"
import script from "./ItemReasonCode.vue?vue&type=script&lang=js&"
export * from "./ItemReasonCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports